<template>
  <el-container>
    <el-main v-if="orders">
      <el-row
        type="flex"
        justify="space-start"
        :gutter="30"
      >
        <el-col :span="18">
          <el-card class="box-card">
            <div class="card-header">
                <h4 class="card-title">Bookings</h4>
                <p><strong>Showing: </strong><span class="text-info">{{filters[0].value | niceStatus}} </span>orders from <span class="text-info">{{filters[1].value | niceRegion}}</span> from <span class="text-info">{{filters[2].value[0] | moment("MMMM Do YYYY")}}</span>  <span class="text-primary">to</span><span class="text-info">  {{filters[2].value[1] | moment("MMMM Do YYYY")}}</span></p>

            </div>

            <div class="table-responsive">

              <el-row style="margin-top:30px; margin-bottom: 10px">

                <el-col :span="5">
                  <label class="control-label">Status:</label><br>
                  <el-select v-model="filters[0].value" placeholder="select status">
                    <el-option label="All" value="ALL"></el-option>
                    <el-option label="Pending" value="0"></el-option>
                    <el-option label="Partially Paid" value="1"></el-option>
                    <el-option label="Fully Paid" value="2"></el-option>
                    <!--<el-option label="3" value="3"></el-option>-->
                    <el-option label="Cancelled" value="4"></el-option>
                  </el-select>
                </el-col>

                <el-col :span="5">
                  <label class="control-label">Region:</label><br>
                  <el-select v-model="filters[1].value" placeholder="select region">
                    <el-option label="All" value="ALL"></el-option>
                    <el-option label="UK" value="TEFLORG"></el-option>
                    <el-option label="US" value="TEFLUS"></el-option>
                    <el-option label="EU" value="IRELAND"></el-option>
                    <el-option label="AUS" value="AUSTRALIA"></el-option>
                    <el-option label="CAD" value="CANADA"></el-option>
                  </el-select>
                </el-col>

                <el-col :span="7">
                  <label class="control-label">Select Date Range</label><br>
                  <el-date-picker  
                    v-model="filters[2].value" 
                    type="daterange"
                    align="right" 
                    unlink-panels range-separator="-" 
                    start-placeholder="Start date" 
                    end-placeholder="End date" 
                    :picker-options="pickerOptions1">
                  </el-date-picker>
                </el-col>
                
              </el-row>



            <data-tables-server 
              class="table-shopping" 
              style="width: 100%" 
              :data="orders" 
              :tool-bar="false" 
              :current-page="1" 
              :total="total"
              :loading="loadingOrders"
              :page-size="20"
              @query-change="whichFunction"
              :filters="filters"
              :pagination-props="{ pageSizes: [5, 10, 15, 20, 50] }">

                <el-table-column
                  min-width="50"
                  label="ID"
                  prop="id"
                >
                  <template slot-scope="props">
                    <span>{{props.row.id}} </span>
                  </template>
                </el-table-column>

                <el-table-column
                  label="Created"
                  min-width="80"
                  prop="dateCreated"
                  sortable="custom"
                >
                  <template slot-scope="props">
                    {{props.row.dateCreated | moment('DD-MM-YYYY') }}<br />
                    <small>{{props.row.dateCreated | moment("HH:mm:ss") }}</small>
                  </template>
                </el-table-column>

                <el-table-column
                  min-width="120"
                  class="td-price"
                  label="Customer"
                >
                  <template slot-scope="props">
                    <router-link
                      v-if="props.row.customer"
                      :to="'/customer/edit/'+props.row.customer.id"
                    >{{props.row.customer.firstname}} {{props.row.customer.lastname}}</router-link>
                  </template>
                </el-table-column>

                <el-table-column
                  min-width="80"
                  class="td-price"
                  label="Region"
                >
                  <template slot-scope="props">
                    {{props.row.productPriceLabel}}
                  </template>
                </el-table-column>

                <el-table-column
                  label="Status"
                  min-width="90"
                  prop="status"
                >
                  <template slot-scope="props">

                    <span
                      class="text-info"
                      v-if="props.row.status=='1'"
                    >Deposit Paid</span>
                    <span
                      class="text-danger"
                      v-else-if="props.row.status=='0'"
                    >No Payment</span>
                    <span
                      class="text-success"
                      v-else-if="props.row.status=='2'"
                    ><span class="ti-check"></span> Fully Paid</span>
                    <span
                      class="text-warning"
                      v-else-if="props.row.status=='attempted'"
                    >Attempted</span>
                    <span
                      class="text-danger"
                      v-else-if="props.row.status=='4'"
                    ><span class="ti-close"></span> Cancelled</span>
                    <span
                      class="text-success"
                      v-else-if="props.row.status=='reserved'"
                    >Reserved</span>
                    <span
                      class="text-info"
                      v-else
                    >{{props.row.status}}</span>

                  </template>
                </el-table-column>

                <el-table-column
                  min-width="120"
                  class="td-price"
                  prop="totalPaid"
                  label="Total"
                >
                  <template slot-scope="props">
                    <span
                      v-if="props.row.productPriceLabel=='TEFLORG'"
                    >£{{props.row.totalPaid}}</span>
                    <span
                      v-if="props.row.productPriceLabel=='TEFLUS'"
                    >${{props.row.totalPaid}}</span>
                    <span
                      v-if="props.row.productPriceLabel=='IRELAND'"
                    >€{{props.row.totalPaid}}</span>
                    <span
                      v-if="props.row.productPriceLabel=='AUSTRALIA'"
                    >A${{props.row.totalPaid}}</span>
                    <span
                      v-if="props.row.productPriceLabel=='CANADA'"
                    >CA${{props.row.totalPaid}}</span>
                  </template>
                </el-table-column>

                

                <el-table-column
                  label="Edit"
                  min-width="50"
                >
                  <template slot-scope="props">
                    <router-link :to="'/order/edit/'+props.row.id">Edit</router-link>
                  </template>
                </el-table-column>

              </data-tables-server>
              
              <br />
            </div>
          </el-card>

        </el-col>

        <el-col :span="6">
          <el-card class="box-card" v-if="this.aggregate.sum">
            <div class="card-header">
              <h4 class="card-title">Stats</h4>
              <p class="category">Stats for your chosen filters <br><small>(note all currencies are grouped into GBP so these values are approximate only.)</small></p>
              <br>
              <h5 style="margin-bottom:-15px;">Total:</h5>
              <h3 v-if="this.aggregate.sum.totalPaid != null">£{{this.aggregate.sum.totalPaid.toLocaleString(undefined, { maximumFractionDigits: 2 })}}</h3>
              <h3 v-if="this.aggregate.sum.totalPaid === null">N/A</h3>
              <h5 style="margin-bottom:-15px;">Orders:</h5>
              <h3 v-if="this.aggregate.count != null">{{this.aggregate.count.toLocaleString(undefined, { maximumFractionDigits: 0 })}}</h3>
              <h5 style="margin-bottom:-15px;">Average order value:</h5>
              <h3 v-if="this.aggregate.sum.totalPaid != null">£{{this.aggregate.avg.totalPaid.toLocaleString(undefined, { maximumFractionDigits: 2 })}}</h3>
              <h3 v-if="this.aggregate.sum.totalPaid === null">N/A</h3>
            </div>

          </el-card>
        </el-col>
      </el-row>

    </el-main>
  </el-container>
</template>
<script>
import _ from "lodash";
import gql from "graphql-tag";
import moment from "moment";
export default {
  data() {
    return {
      loadingOrders: false,
      $Chartist: null,
      filters: [
        {
          value: "2",
          prop: "status",
        }, 
        {
          value: "ALL",
          prop: "productPriceLabel"
        },
        {
          value: [
            moment().subtract(1, "months").format("YYYY-MM-DD"),
            moment().format("YYYY-MM-DD")
          ],
          prop: "dateCreated"
        }
      ],
      pickerOptions1: {
        shortcuts: [
          {
            text: "Last 24 hours",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "Last week",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "Two Weeks",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 14);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "Last month",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "3 months",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "6 months",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "1 year",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      orders: [],
      aggregate: [],
      total: 0
    };
  },
  filters: {
    toArray(obj) {
      if (!(obj instanceof Object)) return obj;
      return _.map(obj, function(val, key) {
        return Object.defineProperty(val, "$key", {
          __proto__: null,
          value: key
        });
      });
    }
  },
  methods: {

    whichFunction(queryInfo){
      if (this.$route.params.transaction) {
        this.getOrderByTransaction(this.$route.params.transaction);
      } else {
        this.loadData(queryInfo);
      }  
    },

    getOrderByTransaction(id) {

      var page = 1;
      var pageSize = 20;
      var orderDir = 'desc_nulls_last';
      var orderProp = 'dateCreated';

      this.$apollo
      .query({
        // desc_nulls_last filters out any null data
        query: gql`
          {
            Order(
                limit: ${pageSize}, 
                offset: ${(page - 1) * pageSize}, 
                order_by: {${orderProp}: ${orderDir}}, 
                where: {transactions: {reference: {_eq: "${id}"}}}) {
              id
              dateCreated
              customer {
                firstname
                lastname
                id
              }
              status
              totalPaid
              totalDue
              productPriceLabel
            }
            Order_aggregate(
                where: {transactions: {reference: {_eq: "${id}"}}})
              {
                aggregate {
                  sum {
                    boughtProductTotalDiscounted
                    boughtProductTotal
                    totalPaid
                    totalDue
                    totalRefunded
                    totalDiscrepent
                  }
                  count
                  avg {
                    totalDue
                    totalPaid
                    boughtProductTotal
                    boughtProductTotalDiscounted
                  }
                }
              }
          }
        `,
        // can get error if needed
        error(error) {
          this.error = JSON.stringify(error);
        }
      })
      .then(response => {
        this.orders = response.data.Order;
        this.aggregate = response.data.Order_aggregate.aggregate;
        this.total = response.data.Order_aggregate.aggregate.count;
        this.loadingOrders = false;
      });
    },

    async loadData(queryInfo) {

      this.loadingOrders = true;
      
      if ( queryInfo != undefined ) {

        var type = queryInfo.type;
        var page = queryInfo.page;
        var pageSize = queryInfo.pageSize;
        var orderDir = 'desc_nulls_last';
        var orderProp = 'dateCreated';

       // (queryInfo.type === 'page' || queryInfo.type === 'size' || queryInfo.type === 'sort') &&
       // this.$message(`page: ${queryInfo.page}, pageSize: ${queryInfo.pageSize}, prop: ${queryInfo.sort.prop}, order: ${queryInfo.sort.order}`)

        
        if (queryInfo.sort.order === 'ascending') {
          orderDir = 'asc_nulls_last';
        } else if (queryInfo.sort.order === 'descending') {
          orderDir = 'desc_nulls_last';
        } else {}
        if (queryInfo.sort.prop != undefined) {
          orderProp = queryInfo.sort.prop;
        }

      } else {

        var type = 'init';
        var page = 1;
        var pageSize = 20;
        var orderDir = 'desc_nulls_last';
        var orderProp = 'dateCreated';

      }

      console.log('queryinfo: ', queryInfo)
      console.log('loading data...')

      //Defaults
      var startDate = moment(this.filters[2].value[0]).format("YYYY-MM-DD");
      var endDate = moment(this.filters[2].value[1]).add(1,'day').format("YYYY-MM-DD");

      var equal = this.filters[1].value === "ALL" ? "_neq" : "_eq"
      var equalStatus = this.filters[0].value === "ALL" ? "_neq" : "_eq"

      this.$apollo
        .query({
          // desc_nulls_last filters out any null data
          query: gql`
            {
              Order(
                limit: ${pageSize}, 
                offset: ${(page - 1) * pageSize}, 
                order_by: {${orderProp}: ${orderDir}}, 
                where: { 
                  _and: [
                    {${this.filters[0].prop}: {${equalStatus}: "${this.filters[0].value}"}},
                    {productPriceLabel: {${equal}: "${this.filters[1].value}"}},
                    { dateCreated: {_gte: "${startDate}"}},
                    { dateCreated: {_lte: "${endDate}"}}
                  ]
                }
              ) {
                id
                dateCreated
                customer {
                  firstname
                  lastname
                  id
                }
                status
                totalPaid
                totalDue
                productPriceLabel
              }
              Order_aggregate(
                where: { 
                  _and: [
                    {${this.filters[0].prop}: {${equalStatus}: "${this.filters[0].value}"}},
                    {productPriceLabel: {${equal}: "${this.filters[1].value}"}},
                    { dateCreated: {_gte: "${startDate}"}},
                    { dateCreated: {_lte: "${endDate}"}}
                  ]
                }
              ) {
                aggregate {
                  sum {
                    boughtProductTotalDiscounted
                    boughtProductTotal
                    totalPaid
                    totalDue
                    totalRefunded
                    totalDiscrepent
                  }
                  count
                  avg {
                    totalDue
                    totalPaid
                    boughtProductTotal
                    boughtProductTotalDiscounted
                  }
                }
              }
            }
          `,
          // can get error if needed
          error(error) {
            this.error = JSON.stringify(error);
          }
        })
        .then(response => {
          this.orders = response.data.Order;
          this.aggregate = response.data.Order_aggregate.aggregate;
          this.total = response.data.Order_aggregate.aggregate.count;
          this.loadingOrders = false;
        });
    }
  },

  async mounted() {
    console.log(this.$route.params);
    if (this.$route.params.transaction) {
      this.getOrderByTransaction(this.$route.params.transaction);
    } else {
      this.loadData();
    }
  },
  
  watch: {
    "$route.params": function(param) {
      if (param.hasOwnProperty("transaction")) {
        console.log('param: ',param);
        this.getOrderByTransaction(param.transaction);
      }
      else {
        this.loadData();
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Orders/List.vue